<div class="alert alert-info mb-3" role="alert">
  <h6 class="alert-heading fw-semibold">About Voucher Allocations &amp; Credits</h6>
  <p class="mb-2">
    A <strong>Voucher Allocation</strong> represents a pool of funds allocated to your {{ portalSegment }} for a
    specific voucher program. Each allocation has a total dollar amount that can be distributed as individual voucher
    credits to educators.
  </p>
  <p class="mb-2">
    A <strong>Voucher Credit</strong> is an individual award issued to a specific educator from an allocation. Credits
    have a set dollar value, a designated service type, and an expiration date.
  </p>
  <p class="mb-0">
    A credit that has been <strong>issued</strong> has been assigned to an educator but has not yet been used. A credit
    that has been <strong>redeemed</strong> has been applied toward a payment for that educator's service.
  </p>
</div>
